import WebServiceRequest from '../../Api/WebServiceRequest'

class UsersChangeUserRoleRequest extends WebServiceRequest {
    constructor (context) {
        super(context)
    }
    setParams(data){
        super.setTag('Users/ChangeUserRole?userId='+data.userId+'&UserTypeId='+data.UserTypeId)
    }
}
export default UsersChangeUserRoleRequest;
